const ONE_TO_ONE = '(1, 1)';
const ZERO_TO_ONE = '(0, 1)';
const ZERO_TO_MANY = '(0, N)';
const ONE_TO_MANY = '(1, N)';
const OBJECT = 'object';
const STRING = 'string';
const ARRAY = 'array';
const EQUALITY = 'Equality Condition';
const INEQUALITY = 'Inequality Condition';

const isSetContain = function (set, obj) {
  let contain = false;
  for (const setObj of set) {
    if (
      setObj.entityName === obj.entityName &&
      setObj.paramName === obj.paramName &&
      setObj.constraint === obj.constraint
    ) {
      contain = true;
      break;
    }
  }
  return contain;
};

const areSetsEqual = (set1, set2) =>
  set1.size === set2.size &&
  [...set1].every(value => isSetContain(set2, value));

const set2ContainSet1 = (set1, set2) =>
  set1.size <= set2.size && [...set1].every(value => isSetContain(set2, value));

export default {
  ONE_TO_ONE,
  ZERO_TO_ONE,
  ZERO_TO_MANY,
  ONE_TO_MANY,
  OBJECT,
  STRING,
  ARRAY,
  EQUALITY,
  INEQUALITY,
  areSetsEqual,
  set2ContainSet1,
};
